
import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatRadioModule } from '@angular/material/radio';
import { AbstractControl, ControlValueAccessor, FormBuilder, FormControl, FormsModule, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule, ValidationErrors, Validator, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { QuestionType } from 'src/app/models/questionType.model';
import { OptionsList } from 'src/app/models/optionsList.model';
import { Question } from 'src/app/models/question.model';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MiniOperationsStore } from 'src/app/store/mini-operations-store';
import { RichTextComponent } from 'src/app/shared/components/rich-text/rich-text.component';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { DisplayByTypeDirective } from '../../display-by-type.directive';
import { combineLatest, startWith } from 'rxjs';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
    selector: 'que-big-title-question',
    imports: [CommonModule, ReactiveFormsModule, FormsModule, MatCheckboxModule, RichTextComponent, TranslateDirective, TranslatePipe, DisplayByTypeDirective, SvgIconComponent],
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: BigTitleQuestionComponent,
            multi: true
        },
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: BigTitleQuestionComponent,
            multi: true
        }
    ],
    templateUrl: './big-title-question.component.html',
    styleUrls: ['./big-title-question.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BigTitleQuestionComponent implements OnInit, ControlValueAccessor, Validator {
  @Input() index?: number;
  @Input() question?: Question | null;
  @Input() typeId?: number;
  #operationsStore = inject(MiniOperationsStore)

  // @Output() focusEvent = new EventEmitter<boolean>();
  // isOrange: string = '';
  typeImage: string = "";
  color$ = inject(QuestionnaireStore).mainColor$;
  #builder = inject(FormBuilder);
  // questionForm = this.#builder.group({
  //   id: [-1],
  //   type: new FormControl<QuestionType>({ id: -1, name: 'sds', category: -1, image: "" }),
  //   title: new FormControl<string>('', [Validators.required]),
  //   text: new FormControl<string>(''),
  //   optionsList: new FormControl<OptionsList | null>(null),

  //   requierd: new FormControl<boolean>(false),
  //   collectionQuestionId: new FormControl<number | null>(null),
  //   stepId: [-1],
  // });

  text = new FormControl<string>('');
  title = new FormControl<string>('', [Validators.required]);

  registerOnChangeCallback: any = () => { };
  onValidationChangeCallBack: any;

  ngOnInit(): void {
    combineLatest([
      this.text.valueChanges.pipe(startWith(this.text.value)),
      this.title.valueChanges.pipe(startWith(this.title.value))
    ]).subscribe(([text, title]) => {
      this.registerOnChangeCallback({ text, title });
    });
  }

  validate(control: AbstractControl<any, any>): ValidationErrors | null {
    if (this.text.valid && this.title.valid) {
      return null;
    }
    return { 'optionsValue': "not-valid" }
  }
  // writeValue(obj: String[]): void {
  //   this.optionsValue.patchValue({ op1:obj[0],op2:obj[1] }, { emitEvent: false });
  //   //this.onValidationChangeCallBack();xxx
  // }
  writeValue(obj: any): void {
    if (obj?.text)
      this.text.patchValue(obj.text)
    if (obj?.title)
      this.title.patchValue(obj.title)
    // this.questionForm.patchValue({ ...obj }, { emitEvent: false });
    // this.typeImage=obj.type.image??"";
    //this.onValidationChangeCallBack();xxx
  }
  registerOnValidatorChange?(fn: () => void): void {
    this.onValidationChangeCallBack = fn;
  }

  registerOnChange(fn: any): void {
    this.registerOnChangeCallback = fn;
  }
  registerOnTouched(fn: any): void {
  }
  menuOpened(ev: boolean) {
    // this.focusEvent.emit(ev);
  }
  saveChanges() {
    this.registerOnChangeCallback({ text: this.text.value, title: this.title.value });
  }
}
